import { render } from "./ApprovalsListCardName.vue?vue&type=template&id=8797d4c2"
import script from "./ApprovalsListCardName.vue?vue&type=script&lang=js"
export * from "./ApprovalsListCardName.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__